<!-- src/components/BaseChart.vue -->
<template>
  <v-chart
    :option="option"
    :autoresize="true"
    style="width: 100%; height: 40vh;"
    v-if="option"
  />
</template>

<script setup>
import { defineProps, watchEffect } from 'vue';
import { use } from 'echarts/core';
import VChart from 'vue-echarts';
import {
  CanvasRenderer
} from 'echarts/renderers';
import {
  BarChart,
  LineChart,
  PieChart
} from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  AxisPointerComponent
} from 'echarts/components';

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  AxisPointerComponent
]);

const props = defineProps({
  option: Object
});
</script>

<style scoped>
/* Ajuste opcional */
</style>
